export const styleConfig = {
  node: {
    width: 200,
    padding: 8,
  },
  title: {
    height: 24,
    lineHeight: "24px",
  },
  titleMarginBottom: 6,
  item: {
    height: 40,
    marginBottom: 7,
  },
  divider: {
    height: 24,
    lineHeight: "20px",
  },
};
